module.exports = __webpack_public_path__ + "static/flyer-06ef300fd502c051e3cc157bf465a7bd.png";